// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_hx-a";
export var fulfillmentFormRail = "_hx-9";
export var headerTitleRow = "_hx-c";
export var orderDetailsWrapper = "_hx-7";
export var orderLinkTrigger = "_hx-2";
export var paymentInformationGrid = "_hx-h";
export var paymentSummaryColumn = "_hx-i";
export var shipmentContainer = "_hx-b";
export var shipmentDetailsMainPane = "_hx-8";
export var shipmentNavigationCard = "_hx-5";
export var shipmentNavigationRail = "_hx-3";
export var shipmentNavigationRailHeader = "_hx-4";
export var shipmentSummaryFact = "_hx-e";
export var shipmentSummaryGrid = "_hx-d";
export var shipmentSummaryMetadataRow = "_hx-f";
export var shipmentSummaryTags = "_hx-g";
export var shipmentWorkspace = "_hx-0";
export var shipmentWorkspaceContent = "_hx-6";
export var shipmentWorkspaceHeader = "_hx-1";